import React from "react";
import InputMask from "react-input-mask";
import {styled} from "@mui/material";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";

const CssTextField = styled(TextField)({
    '& label.Mui-focused': {
        color: '#28ade0',
    },
    '& .MuiInputLabel-root': {
        top: '-6px'
    },
    '& .MuiInput-underline:after': {
        borderColor: '#28ade0',
    },
    '& .MuiOutlinedInput-root': {
        '& input': {
            padding: "7px 15px",
            fontSize: "1.25em",
            color: "#20312D",
        },
        '& fieldset': {
            fontSize: "1.25em",
            borderWidth: '2px',
            borderColor: '#868686'
        },
        '&:hover fieldset': {
            borderColor: '#28ade0',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#28ade0',
        },
    },
});

export default function PhoneNumberTextEdit(props) {
    const {value, onChange} = props;

    return <InputMask
        mask="+999 (99) 999-99-99"
        value={value || ''}
        maskChar="_"
        onChange={onChange ? onChange : () => {}}
    >
        {() => <CssTextField {...props} />}
    </InputMask>
}

PhoneNumberTextEdit.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
}